<template>
    <div class="p-4" :style="{ backgroundColor: data.backgroundColor || '#dbeafe', borderLeft: `4px solid ${data.borderColor || '#3b82f6'}`, borderRadius: '4px', border: data.hasRedLine ? '2px solid red' : 'none' }">
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tr>
                <td width="24px" style="vertical-align: top; padding-right: 12px;">
                    <span class="text-lg">{{ data.icon || 'ℹ️' }}</span>
                </td>
                <td style="vertical-align: top;">
                    <h4 class="font-bold text-base mb-2" :style="{ color: data.textColor || '#1e40af', margin: '0 0 8px 0' }">
                        {{ data.title || 'Belangrijk' }}
                    </h4>
                    <p class="text-sm leading-relaxed" :style="{ color: data.textColor || '#1e40af', margin: '0' }" v-html="processRedMarkersForPreview(data.content)"></p>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import { processRedMarkersForPreview } from './redMarkHelpers';

export const ALERT_TYPES = {
    info: { backgroundColor: '#dbeafe', borderColor: '#3b82f6', textColor: '#1e40af', icon: 'ℹ️', title: 'Informatie', content: 'Dit is een informatieve mededeling.' },
    warning: { backgroundColor: '#fef3c7', borderColor: '#f59e0b', textColor: '#92400e', icon: '⚠️', title: 'Waarschuwing', content: 'Dit is een waarschuwing.' },
    success: { backgroundColor: '#d1fae5', borderColor: '#10b981', textColor: '#065f46', icon: '✅', title: 'Succes', content: 'Actie succesvol uitgevoerd.' },
    error: { backgroundColor: '#fee2e2', borderColor: '#ef4444', textColor: '#991b1b', icon: '❌', title: 'Fout', content: 'Er is een fout opgetreden.' }
};

export default {
    name: 'AlertBlock',
    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        updateAlertType(type) {
            const typeData = ALERT_TYPES[type];
            if (typeData) {
                this.$emit('update', { ...this.data, ...typeData, type });
            }
        },
        processRedMarkersForPreview,
        processRedMarkers(text) {
            if (!text) return '';
            return text.replace(/\[RED\](.*?)\[\/RED\]/g, '<span @if($show_clues)="" style="border: solid red 2px;" @endif="">$1</span>');
        },
        generateHTML() {
            let processedContent = this.data.content || '';
            processedContent = this.processRedMarkers(processedContent);
            
            const bgColor = this.data.backgroundColor || '#dbeafe';
            const borderColor = this.data.borderColor || '#3b82f6';
            const textColor = this.data.textColor || '#1e40af';
            
            const styleAttr = this.data.hasRedLine
                ? `@if($show_clues) style="background-color: ${bgColor}; border-left: 4px solid ${borderColor}; border: solid red 2px; padding: 16px; margin-bottom: 20px;" @else style="background-color: ${bgColor}; border-left: 4px solid ${borderColor}; padding: 16px; margin-bottom: 20px;" @endif`
                : `style="background-color: ${bgColor}; border-left: 4px solid ${borderColor}; padding: 16px; margin-bottom: 20px;"`;
            
            return `
                <table width="100%" border="0" cellspacing="0" cellpadding="0" ${styleAttr} bgcolor="${bgColor}">
                    <tr>
                        <td>
                            <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td width="24" valign="top" style="vertical-align: top; padding-right: 12px; font-family: Arial, sans-serif; font-size: 18px; line-height: 24px;">
                                        ${this.data.icon || 'ℹ️'}
                                    </td>
                                    <td valign="top" style="vertical-align: top;">
                                        <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                            <tr>
                                                <td style="font-family: Arial, sans-serif; margin: 0 0 8px 0; color: ${textColor}; font-size: 16px; font-weight: bold; line-height: 20px;">
                                                    ${this.data.title || 'Belangrijk'}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="font-family: Arial, sans-serif; margin: 0; color: ${textColor}; font-size: 14px; line-height: 21px;">
                                                    ${processedContent}
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            `;
        },
        getDefaultData() {
            return {
                type: 'info',
                title: 'Belangrijk',
                content: 'Dit is een belangrijke mededeling.',
                backgroundColor: '#dbeafe',
                borderColor: '#3b82f6',
                textColor: '#1e40af',
                icon: 'ℹ️',
                hasRedLine: false
            };
        }
    }
}
</script>
